module.exports = __webpack_public_path__ + "img/ubereats.0f01be0e.png";